import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const PPMobileCardView = ({ title, id, rows = [], menuItems, children, onClick }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    const headerRows = rows.filter(row => row.inHeader);
    const gridRows = rows.filter(row => !row.inHeader);
    // Title-only cards (no fields / extra content) don't need the header divider or the empty body
    const hasBody = gridRows.length > 0 || Boolean(children);

    const renderCell = (row, i, className) => (
        <div className={className} key={i}>
            {!row.hideLabel && <div className="pp-card-label">{row.label}</div>}
            <div
                className={`pp-card-value${row.bold ? ' pp-card-value-bold' : ''}`}
                style={{
                    ...(row.fontSize && { fontSize: row.fontSize }),
                    ...(row.maxWidth && { maxWidth: row.maxWidth }),
                }}
            >
                {row.value}
            </div>
        </div>
    );

    return (
        <div className={`pp-card${onClick ? ' pp-card-clickable' : ''}`} onClick={onClick}>
            <div className={`pp-card-header${hasBody ? '' : ' pp-card-header-only'}`}>
                <div>
                    <span className="pp-card-title">{title}</span>
                    {id && <span className="pp-card-id"> #{id}</span>}
                </div>
                <div className="pp-card-header-right">
                    {headerRows.map((row, i) => renderCell(row, i, 'pp-card-header-cell'))}
                    {menuItems && (
                        <IconButton size="small" onClick={handleOpen} style={{ padding: 2 }}>
                            <MoreVertIcon fontSize="small" />
                        </IconButton>
                    )}
                </div>
            </div>
            {gridRows.length > 0 && (
                <div className="pp-card-grid">
                    {gridRows.map((row, i) =>
                        renderCell(row, i, `pp-card-cell${row.fullWidth ? ' pp-card-cell-full' : ''}`)
                    )}
                </div>
            )}
            {children}
            {menuItems && (
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    // Menu is portaled, but React still bubbles its clicks to the card's onClick
                    onClick={(e) => e.stopPropagation()}
                >
                    {menuItems.map((item, i) => (
                        <MenuItem key={i} onClick={(e) => { handleClose(); item.onClick(e); }}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    );
};

export default PPMobileCardView;
